import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSingleProduct } from "../actions/storeActions";
import DeliveryDetail from "../components/Product/DeliveryDetail";
import Loading from "../helpers/Loading";
import ProductDescription from "../components/Product/ProductDescription";
import ProductDetail from "../components/Product/ProductDetail";
import Popup from "../helpers/Popup";
const Product = () => {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  // const [message, setMessage] = useState(null);

  useEffect(() => {
    (async function getTheSingleProduct() {
      const data = await getSingleProduct(id);

      setProduct(data);
    })();
  }, []);

  if (product === null) return <Loading />;

  return (
    <>
      <Popup />
      <div className="product_container">
        <div className="product_main_container">
          <div className="product_detail_container">
            <ProductDetail data={product} />
            <ProductDescription
              description={product.description}
              type={product.type}
              category={product.category}
            />
          </div>
          <div className="product_delivery_detail">
            <DeliveryDetail />
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
